import React, {Component} from 'react';
import PropTypes from 'prop-types';

import connect from "react-redux/es/connect/connect";
import Header from "../elements/Header";
import ListButton from "../elements/ListButton";
import Economy from "../../assets/img/icons/economy/economy.svg";
import TaxItemContainer from "../elements/TaxItemContainer";
import {__} from "i18n-for-browser";
import TaxItem from "./TaxItem";
import Calculator from "../../assets/img/icons/L-belasting-1.svg";
import {ministryIcons} from "../../assets/assets";
import PopupTitle from "../elements/PopupTitle";
import Belasting6 from "../../assets/img/icons/belasting-6.svg";
import ContentContainer from "../elements/ContentContainer";
import IncomeDetail from "../elements/IncomeDetail";
import Budget from "../../assets/img/icons/budget.png";
import VerliesGlobas from "../../assets/img/icons/economy/min-globas.svg";
import WinstGlobas from "../../assets/img/icons/economy/up-globas.svg";
import Belasting5 from "../../assets/img/icons/belasting-5.svg";
import Belasting7 from "../../assets/img/icons/belasting-7.svg";
import config from '../../config';

import {
  getText,
  getImageText,
  getImage,
  getPoints,
  getOverigeInkomsten,
  calculateDebitCreditOutcomeBasic
} from "../../helpers/feedbackHelpers";
import EconomyTotal from "../elements/EconomyTotal";

class TaxesLow extends Component {
  static propTypes = {
    inheritedState: PropTypes.object.isRequired,
  };
  static defaultProps = {
    desktop: false
  };
  constructor (props) {
    super(props);
    this.state = {
      showReceivedInterestDropdown: false,
      showPaidInterestDropdown: false,
      showOtherIncomeDropdown: false,
      showBudgetDropdown: false,
      showEconomy: false,
    };
  }

  toggleOther(property) {
    const state = { ...this.state };
    state[property] = !state[property];
    this.setState(state);
  }

  validateTaxOne = () => {
    const { gameStateInput: { myState: state } } = this.props;
    const ab = state.arbeidsBelasting >= 1 && state.arbeidsBelasting <= 79;
    return ab;
  };

  getWinstVerliesEffect = fb => ({
    icon: parseInt(fb.winstverliesglobas, 10) >= 0 ? WinstGlobas : VerliesGlobas,
    title: parseInt(fb.winstverliesglobas, 10) >= 0 ? __('sim_winstglobas') : __('sim_verliesglobas'),
    contentTitle: fb.winstverliesglobas || 0,
    contentUnit: __('sim_miljard'),
  });

  getEffects = fb => {
    const effects = [];
    if (fb.economie) {
      effects.push(this.getWinstVerliesEffect(fb.economie));
    }
    return effects.concat((fb.overigeEffecten || []).map((oe) => ({
      icon: ministryIcons[oe.ministerie],
      title: __(oe.ministerie),
      contentTitle: getPoints(oe),
      contentUnit: __('sim_punten'),
    })));
  };

  getOISum = (overigeInkomsten, replacementChar) => overigeInkomsten.reduce((sum, oi) => {
    sum += parseInt(oi.winstverliesglobas, 10) || 0;
    return sum;
  }, 0) || (replacementChar || 0);

  getTotalBudgetGlobas = (state, oi, isBankDisabledForSimulation) => {
    const spaar = this.props.gameState.prevRoundSum.OneTimeEffect.debitCredit
      .map(entry => calculateDebitCreditOutcomeBasic(entry, isBankDisabledForSimulation))
      .filter(i => i && i.key)
      .reduce((acc, i) => {
        if(i.key === 'stortenSpaargeld') {
          return acc+ (-i.amount);
        }
        return acc+-i.amount;
      }, 0);
    return state.AB_globas + this.getOISum(oi) + spaar;
  };

  render() {
    const { gameState, gameStateInput, feedback, desktop, project } = this.props;
    const { state } = this;
    const { myState } = gameStateInput;
    const { gameStateSum } = gameState.roundData;
    const { belastingFeedback } = feedback;
    const overigeInkomsten = getOverigeInkomsten(feedback.prevRoundFeedbackData, gameState, project.minPolicyChoices);

    const { prevRoundSum } = this.props.gameState;
    let teBetalen = null;
    let teOntvangen = null;

    let isBankDisabledForSimulation = false;
    if (myState && myState.SIMULATION_TAX === 'PROCESSED') {
      const currDC = gameState.roundData && gameState.roundData.lastGameState && gameState.roundData.lastGameState.OneTimeEffect && gameState.roundData.lastGameState.OneTimeEffect.debitCredit;
      isBankDisabledForSimulation = currDC ? currDC.some(c => c.bankDisabledPayout) : false;
    } else {
      isBankDisabledForSimulation = project.bankEnabled === false;
    }

    if(prevRoundSum && prevRoundSum.OneTimeEffect && prevRoundSum.OneTimeEffect.debitCredit) {
      teBetalen = prevRoundSum.OneTimeEffect.debitCredit
      .map(entry => calculateDebitCreditOutcomeBasic(entry, isBankDisabledForSimulation))
      .filter(item => item != null && item.amount > 0)
      .reduce((b, a) =>  a.amount + b, 0);

      teOntvangen = prevRoundSum.OneTimeEffect.debitCredit
      .map(entry => calculateDebitCreditOutcomeBasic(entry, isBankDisabledForSimulation))
      .filter(item => item != null && item.amount < 0 && item.key !== "stortenSpaargeld")
      .reduce((b, a) =>  a.amount + b, 0);
    }

    let schuld = this.props.gameState.prevRoundSum.OneTimeEffect.debitCredit
      .filter(i => i.key === 'lenenVanBank')
      .map(entry => calculateDebitCreditOutcomeBasic(entry, isBankDisabledForSimulation))
      .filter(i => i && i.key)
      .reduce((acc, i) => acc+-i.amount, 0);
    let spaargeld = this.props.gameState.prevRoundSum.OneTimeEffect.debitCredit
      .filter(i => i.key === 'stortenSpaargeld')
      .map(entry => calculateDebitCreditOutcomeBasic(entry, isBankDisabledForSimulation))
      .filter(i => i && i.key)
      .reduce((acc, i) => {
        if(i.key === 'stortenSpaargeld') {
          return acc+ (-i.amount);
        }
        return acc+-i.amount;
      }, 0);
    if (!schuld) schuld = false;
    if (!spaargeld) spaargeld = false;
    spaargeld = spaargeld || 0;
    schuld = schuld || 0;

    const taxVideo = gameState.language === 'NL' ? `${config.uploadsUrl}/assets/videos/belasting_LAAG_NL_720p_1,5Mbps.mp4` : `${config.uploadsUrl}/assets/videos/belasting_LAAG_ENG_720p_1,5Mbps.mp4`;
    return (
      <div>
        {
          !desktop ? (
            <Header history={this.props.history} historic={false} buttonType='view' viewType='list' showTitle={true}/>
          ) : null
        }
        <div className='container taxes laag'>
          <PopupTitle popupId={'dlgvteconomie'} tag={'h3'}/>
          <ListButton
            bgColor='darkblue'
            title={__('sim_totalglobas')}
            icon={Economy}
            globas={gameState.totalEconomy}
            hidePoints={true}
            onClick={() => this.setState({showEconomy: !state.showEconomy})}/>

          { state.showEconomy ? (
            <EconomyTotal/>
          ) : null }

          {/* Tax step 1 */}
          <TaxItemContainer
            title={__('sim_belasting')}
            video={taxVideo}
            saving={myState.SIMULATION_TAX === 'SUBMITTED' || myState.SIMULATION_TAX_2 === 'SUBMITTED'}
            saved={myState.SIMULATION_TAX === 'PROCESSED' && myState.SIMULATION_TAX_2 === 'PROCESSED'}
            showSavedPopup={myState.showSavedPopup === 'SIMULATION_TAX_2'}
            visible={true}
            step={'SIMULATION_TAX'}
            savingMessage={'dlgmstap3opslaan_2'}
            feedbackMessage={'dlgmstap2opslaan_3'}
            buttonConditions={this.validateTaxOne()}
            popupId={'dlgvtbelasting'}
          >
            <TaxItem
              title={__('sim_belastinginkomsten')}
              video={'https://player.vimeo.com/video/265045525'}
              reverseGlobasPoints={true}
              sliderKey={'arbeidsBelasting'}
              points={myState.SIMULATION_TAX !== 'PROCESSED' ? '-' : gameStateSum.AB_points}
              globas={myState.SIMULATION_TAX !== 'PROCESSED' ? '-' : gameStateSum.AB_globas}
              twoValueSlider={true}
              suffix={'%'}
              sliderTitles={[__('sim_belasting'), __('sim_bevolking')]}
              maxValue={100}
              cap={79}
              minValue={0}
              capNotification={__('sim_basic_arbeidsbelasting_te_hoog_percentage_melding')}
              sliderValue={myState.arbeidsBelasting}
              notification={{
                read: belastingFeedback.read,
                reference: belastingFeedback.id,
              }}
              icon={Calculator}
              taxDescription={__('sim_basic_arbeidsbelasting_beschrijving')}
              feedbackData={{
                show: myState.SIMULATION_TAX === 'PROCESSED',
                topData: [],
                img: getImage(belastingFeedback),
                imgDescription: getImageText(belastingFeedback, gameState.language),
                description: getText(belastingFeedback, gameState.language),
                effects: this.getEffects(belastingFeedback),
              }}
              popupId={'dlgvtbelasting'}
              ignorePopup={true}
              showDropdown={this.props.paramsTaxId === 'belasting'}
            />
          </TaxItemContainer>

          <div className={'taxes-section overige-inkomsten'}>
            <PopupTitle popupId={'dlgvtoverigeinkomsten'} tag={'h3'}/>
            <ListButton onClick={this.toggleOther.bind(this, 'showOtherIncomeDropdown')} bgColor='white' title={__('sim_overige_inkomsten')} icon={Belasting6} globas={this.getOISum(overigeInkomsten, '-')} hidePoints={true} arrow={true}/>
            <div className={'other-income' + (this.state.showOtherIncomeDropdown ? ' active' : '')}>
              <ContentContainer>
                {overigeInkomsten.map((oi, i) =>
                  <IncomeDetail
                    key={i}
                    img={oi.icon}
                    title={oi.title}
                    description={getText(oi, gameState.language)}
                    amount={oi.winstverliesglobas + ""}
                    unit={__('sim_miljard')}/>
                )}
              </ContentContainer>
            </div>

            {spaargeld ? (
              <div>
                <ListButton onClick={this.toggleOther.bind(this, 'showReceivedInterestDropdown')} bgColor='white' title={isBankDisabledForSimulation ? __('sim_spaargeld') : __('sim_rente_op_spaargeld')} icon={Belasting5} globas={spaargeld} hidePoints={true} arrow={true}/>
                <div className={'interest-income' + (this.state.showReceivedInterestDropdown ? ' active' : '')}>
                  <ContentContainer>
                    <p>{isBankDisabledForSimulation ? __('sim_basic_spaargeld_bank_uitgeschakeld_uitleg') : __('sim_basic_ontvangen_rente_uitleg')}</p>
                  </ContentContainer>
                </div>
              </div>
            ) : null}

            {schuld ? (
              <div>
                <ListButton onClick={this.toggleOther.bind(this, 'showPaidInterestDropdown')} bgColor='white'
                            title={__('sim_terug_te_betalen_lening')} icon={Belasting7} globas={schuld} hidePoints={true}
                            arrow={true}/>
                <div className={'interest-income' + (this.state.showPaidInterestDropdown ? ' active' : '')}>
                  <ContentContainer>
                    <p>{__('sim_basic_bedrag_vorige_ronde_geleend_uitleg')}</p>
                  </ContentContainer>
                </div>
              </div>
            ) : null}
          </div>

          <div className="plus-minus">
            <span className="plus"/>
          </div>

          <div className={'taxes-section'}>
            <h3>{__('sim_budget')}</h3>
            <ListButton onClick={this.toggleOther.bind(this, 'showBudgetDropdown')} bgColor='white' title={__('sim_totale_budget')} icon={Budget} globas={this.getTotalBudgetGlobas(gameStateSum, overigeInkomsten, isBankDisabledForSimulation)} hidePoints={true} arrow={true}/>
            <div className={'interest-income country-budget' + (this.state.showBudgetDropdown ? ' active' : '')}>
              <ContentContainer>
                {gameStateSum.AB_globas ?
                  <div className={'table-interest'}>
                    <div><p>{__('sim_belastinginkomsten')}</p></div>
                    <div />
                    <div><p>{gameStateSum.AB_globas} {__('sim_miljard')}</p></div>
                  </div>: ''}
                {this.getOISum(overigeInkomsten) ?
                  <div className={'table-interest'}>
                    <div><p>{__('sim_overige_inkomsten')}</p></div>
                    <div />
                    <div><p>{this.getOISum(overigeInkomsten)} {__('sim_miljard')}</p></div>
                  </div> : ''}
                {spaargeld ?
                  <div className={'table-interest'}>
                    <div><p>{isBankDisabledForSimulation ? __('sim_spaargeld') : __('sim_rente_op_spaargeld')}</p></div>
                    <div/>
                    <div><p>{spaargeld} {__('sim_miljard')}</p></div>
                  </div>:
                  ''
                }
                {schuld ?
                  <div className={'table-interest'}>
                    <div><p>{__('sim_terug_te_betalen_lening')}</p></div>
                    <div/>
                    <div><p>{schuld} {__('sim_miljard')}</p></div>
                  </div>:
                  ''
                }
                <div className={'plus-minus'}/>
                <div className={'table-interest bold'}>
                  <div><p>{__('sim_totaal')}</p></div>
                  <div />
                  <div><p>{this.getTotalBudgetGlobas(gameStateSum, overigeInkomsten, isBankDisabledForSimulation)} {__('sim_miljard')}</p></div>
                </div>
              </ContentContainer>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(({gameState, feedback, gameStateInput, project, schoolClass}) => ({gameState, feedback, gameStateInput, project, schoolClass}))(TaxesLow);



// WEBPACK FOOTER //
// ./src/components/desktop/TaxesLow.js